import SigamAPI from '~/utils/SigamAPI';

export default async function GetContacts({ search, institutionId }) {
  const response = await SigamAPI({
    url: `/SIGAM/${institutionId}/people`,
    method: 'POST',
    data: {
      filter: {
        name: search,
      },
      pagination: {
        limit: 0,
      },
    },
  });

  return response;
}
